import React, { useState } from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import Modal from '../../../../Components/Modal/Modal';
import Button from '../../../../Components/Button/Button';
import SUKLCredentialsSetupForm from './SUKLCredentialsSetupForm';
import { Size } from '../../../../Enums/Size.enum';

const SUKLCredentialsSetupWrapper: React.FC = () => {
	const [isSetupOpen, setIsSetupOpen] = useState(false);
	return (
		<>
			<Button
				title='component.certificates.loginSUKL'
				theme={Theme.BLUE}
				onClick={() => setIsSetupOpen(true)}
				className='mt-4'
			/>
			<Modal
				opened={isSetupOpen}
				onClose={() => setIsSetupOpen(false)}
				size={Size.LG}>
				<Modal.Header title='component.userSuklLoginCredentials.title' />
				<Modal.Content>
					<SUKLCredentialsSetupForm onSuccess={() => setIsSetupOpen(false)} />
				</Modal.Content>
			</Modal>
		</>
	);
};

export default SUKLCredentialsSetupWrapper;
